export const GET_VACANCY = 'GET_VACANCY';
export const GET_DOMAIN = 'GET_DOMAIN';
export const POST_APPLICANT = 'POST_APPLICANT';
export const POST_REFERAL = 'POST_REFERAL';
export const GET_REFERAL = 'GET_REFERAL';
export const POST_REFERAL_APPLICANT = 'POST_REFERAL_APPLICANT';
